module.exports = __webpack_public_path__ + "img/defocused-image-of-lights-255379.52d0e140.jpg";